
import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { dispatchView, reportView } from './constant'
import moment from 'moment'
import { connect, useDispatch, useSelector } from 'react-redux'
import * as urls from '../../Reports/oldReportsUrls'
// import { getDispatchRegisterReportFilter, getDispatchRegisterReportTableData, getDispatchRegisterReportVehicleWiseTableData, GetDispatchRegistorMemoTableData } from '../../../../store/reports/reports_action'
import { updateAlertError } from '../../../../store/common/common_action'
import { removeDuplicatesFromArray,appendToUrl, focusElemnt, navigation3} from '../../../common/helper'
import StationWiseDefaultView from './StationWiseDefaultView'
import VehicleWiseDefaultView from './VehicleWiseDefaultView'
import { getReceiptRegisterReportFilter, getReceiptRegisterReportTableData } from '../../../../store/reports/reports_action'



const ReceiptRegisterReport = (props) => {
  const paymentModesWithAll = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Paid' },
    { id: 2, name: 'ToPay' },
  ]
  const dispatch = useDispatch();
   const state = useSelector((state) => state)
   const { common, reports } = state
  const { loginData,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { receiptRegisterFilterData, receiptRegisterReportData} = reports
  const [selDispatchView, setSelDispatchView] = useState(dispatchView[0]);
  const [showReport, setShowReport] = useState(false);
  const [selReportView, setSelReportView] = useState([])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState([])
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceBranch, setSourceBranch] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [destinationCity, setDestinationCity] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationBranch, setDestinationBranch] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [vehicleNoData, setVehicleNoData] = useState([])
  const [selVehicleNo, setSelVehicleNo] = useState('')
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const reportName = 'Receipt Register'
  const HeaderData = {
    FromDate: moment(fromDate).format("DD-MM-YYYY"),
    ToDate: moment(toDate).format("DD-MM-YYYY"),
    FromCity: selSourceCity?.FromCity,
    FromBranch: selSourceBranch?.FromBranch,
    DispatchView: selDispatchView?.name,
    ToStation: selDestinationCity?.ToCity,
    ToBranch: selDestinationBranch?.DestinationBranch,
    PaymentType: paymentType?.name,
    ReportView: selReportView?.name,
    VehicleNumber:selVehicleNo?.VehicleNo,
  }

  useEffect(() => {
    const SourceCity = [
        { FromCityID: 0, FromCity: 'All' },
        ...[...new Map(receiptRegisterFilterData?.map((val) => 
            [val.FromCityID, { FromCityID: val.FromCityID, FromCity: val.FromCity }]
        )).values()]
    ];

    const SourceBranch = [
        { FromBranchID: 0, FromBranch: 'All' },
        ...[...new Map(receiptRegisterFilterData?.map((val) => 
            [val.FromBranchID, { FromBranchID: val.FromBranchID, FromBranch: val.FromBranch, FromCityID: val.FromCityID }]
        )).values()]
    ];

    const DestinationCity = [
        { ToCityID: 0, ToCity: 'All' },
        ...[...new Map(receiptRegisterFilterData?.map((val) => 
            [val.ToCityID, { ToCityID: val.ToCityID, ToCity: val.ToCity, FromCityID: val.FromCityID }]
        )).values()]
    ];

    const DestinationBranch = [
        { DestinationBranchID: 0, DestinationBranch: 'All' },
        ...[...new Map(receiptRegisterFilterData?.map((val) => 
            [val.DestinationBranchID, { DestinationBranchID: val.DestinationBranchID, DestinationBranch: val.DestinationBranch, ToCityID: val.ToCityID }]
        )).values()]
    ];

    const VehicleNoDropData = [
        ...[...new Map(receiptRegisterFilterData?.map((val) => 
            [val.VehicleID, { VehicleID: val.VehicleID, VehicleNo: val.VehicleNo }]
        )).values()]
    ];

    setSourceCity(SourceCity);
    setSourceBranch(SourceBranch);
    setDestinationCity(DestinationCity);
    setDestinationBranch(DestinationBranch);
    setVehicleNoData(VehicleNoDropData);
    setSelVehicleNo(VehicleNoDropData?.[0] || null);
}, [receiptRegisterFilterData]);


  const callFilterAPI = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData.intCompanyID,
        DateFrom: moment(fromDate).format("YYYY-MM-DD"),
        DateTo: moment(toDate).format("YYYY-MM-DD")
      }
      dispatch(getReceiptRegisterReportFilter(obj))
      setSelSourceCity({ FromCityID: 0, FromCity: 'All' })
      setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
      setSelDestinationCity({ ToCityID: 0, ToCity: 'All' })
      setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })

    }
  }

  const handlekeyDown = (e, prevId, nextId, currentId, currentButton) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      document.getElementById(nextId).focus()
    } else if (e.key === 'Escape') {
      document.getElementById(prevId).focus()
    } else if (e.key === ' ') {
      if (currentButton === 'go') {
        callFilterAPI()
      } else {
        document.getElementById(currentId).click()
      }
    }
  }

  const handleClick = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else{
    setShowReport(true)
      const obj = {
        intFromCityID: selSourceCity?.FromCityID,
        intFromBranchID: selSourceBranch?.FromBranchID,
        intToCityID: selDestinationCity?.ToCityID,
        intToBranchID: selDestinationBranch?.DestinationBranchID,
        intCompanyID: loginData.intCompanyID,
        dtFrom: moment(fromDate).format("YYYY-MM-DD"),
        dtTo: moment(toDate).format("YYYY-MM-DD"),
        intUserID:loginData.intUserID,
        intAmountType: paymentType?.id,
        ...(selDispatchView?.id=== 1? {
                 strVehicleNo: selVehicleNo?.VehicleNo,
                 intVehicleID: selVehicleNo?.VehicleID
            } : {})
        };
      dispatch(getReceiptRegisterReportTableData(obj))
    }
  }
 const handleClick2 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else{ 
        let url = urls.ReceiptRegisterReportStationWise
        let urlData = urls.ReceiptRegisterReportStationWiseParams
        urlData.chk = loginData.BusCrsCheckSum
        urlData.intFromCityID= selSourceCity?.FromCityID
        urlData.intFromBranchID= selSourceBranch?.FromBranchID
        urlData.intToBranchid=selDestinationBranch?.DestinationBranchID
        urlData.intAmountType= paymentType?.id
        urlData.strVehicleNo=selDispatchView?.id=== 0?0:selVehicleNo?.VehicleNo
        urlData.dtfromDate= moment(fromDate).format("DD-MMM-YYYY")
        urlData.dtToDate= moment(toDate).format("DD-MMM-YYYY")
        urlData.intVehicleID=selDispatchView?.id=== 0?0:selVehicleNo?.VehicleID
        urlData.strFromCityName=selSourceCity?.FromCity
        urlData.strFromBranchName=selSourceBranch?.FromBranch
        urlData.strToBranchName=selDestinationBranch?.DestinationBranch
        urlData.intVehicleChk=selDispatchView?.id=== 0?0:1
        urlData.intAllowExportToExcel = 1
        url = appendToUrl(url, urlData)
        window.open(url, '_blank')
        }
  }
  
  useEffect(()=>{
    focusElemnt('fromDate')
  },[])
    
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="selectCompnay"
              prevId={'generateDiv'}
              nextId={'ArrowForwardIosIcon1'}
              label={'Company Name'}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              //   onSelect={(val) => setSelCompany(val)}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon1"
            sx={sx.itemsx}
            className="disabled-wrapper"
            variant="contained"
            disabled={true}
            // onKeyDown={(e) => handlekeyDown(e, 'selectCompnay', 'fromDate', 'ArrowForwardIosIcon1Btn')}
            style={{ ...sx.novp, display: 'flex', justifyContent: 'center', width: '4%', backgroundColor: '#CCC' }}
          >
            <ArrowForwardIosIcon id="ArrowForwardIosIcon1Btn" />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={`Dispatch From Date`}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_dispatch_date'}
              label={'Dispatch To Date'}
              id="toDate"
              nextId={'ArrowForwardIosIcon2'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('ArrowForwardIosIcon2')
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            onKeyDown={(e) => handlekeyDown(e, 'fromDate', 'dispatchByBranch', 'ArrowForwardIosIconBtn', 'go')}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
            }}
          >
            <ArrowForwardIosIcon id="ArrowForwardIosIconBtn" onClick={callFilterAPI} />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From City'}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'ArrowForwardIosIcon2'}
              data={sourceCity}
              dataKey={`FromCity`}
              idKey={`FromCityID`}
              //disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0}
              defaultvalue={selSourceCity?.FromCity || selSourceCity}
              //   value={selFromBranch?.name || ''}
              isObjArr={true}
              onSelect={(val) => setSelSourceCity(val)}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From Branch'}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={sourceBranch || []}
              dataKey={`FromBranch`}
              idKey={`FromBranchID`}
              defaultvalue={selSourceBranch?.FromBranch || selSourceBranch}
              //   value={selDestCity?.name || ''}
              onSelect={(val) => { setSelSourceBranch(val) }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch View'}
              id="destinationBranch"
              nextId={selDispatchView?.name==='Station Wise'?'toStation':'vehicleList'}
              prevId={'destination'}
              data={dispatchView}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelDispatchView(val)
              }}
              defaultvalue={selDispatchView?.name || selDispatchView}
              //   value={selBranch?.name || ''}
              width="100%"
            // minWidth="230px"
            />
          </Item>
          {
            selDispatchView?.name==='Station Wise' ?
              <>
                <Item sx={sx.itemsx}>
                  <DropDownOA
                    label={'To Station'}
                    id="toStation"
                    defaultvalue={selDestinationCity?.ToCity || ''}
                    //   value={selVehicle?.name || ''}
                    data={destinationCity || []}
                    dataKey={`ToCity`}
                    idKey={`ToCityID`}
                    onSelect={(val) => { setSelDestinationCity(val) }}
                    nextId={'toBranch'}
                    prevId={'destinationBranch'}
                    width="100%"
                  />
                </Item>
                <Item sx={sx.itemsx}>
                  <DropDownOA
                    label={'To Branch'}
                    id="toBranch"
                    defaultvalue={selDestinationBranch?.DestinationBranch || selDestinationBranch}
                    //   value={selVehicle?.name || ''}
                    data={destinationBranch || []}
                    dataKey={`DestinationBranch`}
                    idKey={`DestinationBranchID`}
                    onSelect={(val) => { setSelDestinationBranch(val) }}
                    nextId={'paymentType'}
                    prevId={'toStation'}
                    width="100%"
                  />
                </Item>
                <Item sx={sx.itemsx}>
                  <DropDownOA
                    label={'Payment Type'}
                    // data={paymentModesWithAll || []}
                    data={(paymentModesWithAll || []).map((item) => {
                      if (UseToPayAsCOD === 1) {
                        if (item.id === 2) {
                          return { ...item, name: 'COD' };
                        }
                      }
                      return item;
                    }).filter(Boolean)
                    }
                    id="paymentType"
                    nextId={'generateBtn'}
                    prevId={'toBranch'}
                    defaultvalue={paymentType?.name || ''}
                    width="100%"
                    searchPlaceholder={`Search By Payment Type`}
                    tabIndex="2"
                    dataKey={`name`}
                    idKey={`id`}
                    onSelect={(val) => {
                      setPaymentType(val)
                    }}
                  />
                </Item>
                </>
              :
              <>
              
                <Item sx={sx.itemsx}>
                  <DropDownOA
                    label={'Select Vehicle'}
                    id="vehicleList"
                    defaultvalue={selVehicleNo?.VehicleNo || ''}
                    value={selVehicleNo?.VehicleNo || ''}
                    data={vehicleNoData || []}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleID`}
                    onSelect={(val) => { setSelVehicleNo(val) }}
                    nextId={'paymentType'}
                    prevId={'destinationBranch'}
                    width="100%"
                  />
                </Item>
                <Item sx={sx.itemsx}>
                  <DropDownOA
                    label={'Payment Type'}
                    // data={paymentModesWithAll || []}
                    data={(paymentModesWithAll || []).map((item) => {
                      if (UseToPayAsCOD === 1) {
                        if (item.id === 2) {
                          return { ...item, name: 'COD' };
                        }
                      }
                      return item;
                    }).filter(Boolean)
                    }
                    id="paymentType"
                    nextId={'generateBtn'}
                    prevId={'vehicleList'}
                    defaultvalue={paymentType?.name || ''}
                    width="100%"
                    searchPlaceholder={`Search By Payment Type`}
                    tabIndex="2"
                    dataKey={`name`}
                    idKey={`id`}
                    onSelect={(val) => {
                      setPaymentType(val)
                    }}
                  />
                </Item>
              </>
          }

          <Item
            id="generateDiv"
            tabIndex={0}
            sx={sx.itemsx}
          onKeyDown={(e) => navigation3(e, showReport ? "DispatchPrintBtn" : 'fromDate', 'paymentType', () => handleClick())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              prevId={'paymentType'}
              id1={'generateBtn'}
              // id="generateBtn"
              nextId={'fromDate'}
              onClick1={handleClick}
                onClick2={handleClick2}
              disabled={false}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, display: 'none' }}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>

      {showReport ? selDispatchView.id === 0? <StationWiseDefaultView receiptRegisterReportData={receiptRegisterReportData} HeaderData={HeaderData}/> : selDispatchView.id === 1 ? <VehicleWiseDefaultView receiptRegisterReportData={receiptRegisterReportData} HeaderData={HeaderData}/> : ''
        : null
      }
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError}
export default connect(mapStateToProps, mapDispatchToProps)(ReceiptRegisterReport)
